import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IContextCore, IContextDevice, IContextState } from './context.state';

export const selectContextState = createFeatureSelector<IContextState>('context');

export const selectContextCore = createSelector(
  selectContextState,
  (state): IContextCore => {
    if (!!state) {
      return state.core;
    }
    return;
  },
);

export const selectContextDevice = createSelector(
  selectContextState,
  (state): IContextDevice => {
    if (!!state) {
      return state.device;
    }
    return;
  },
);

export const selectDeviceIsMobile = createSelector(selectContextDevice, (state): boolean => {
  if (!!state) {
    return state.isMobile;
  }
  return;
});

export const selectContextDeviceType = createSelector(selectContextDevice, (state): string => {
  if (!!state) {
    return state.type;
  }
  return;
});

export const selectContextLocale = createSelector(selectContextCore, (state): string => {
  if (!!state) {
    return state.locale;
  }
  return;
});

export const selectIsLanding = createSelector(selectContextCore, (state): boolean => {
  if (!!state) {
    return state.isLanding;
  }
  return;
});

export const selectContextLanguage = createSelector(selectContextCore, (state): string => {
  if (!!state) {
    return state.language;
  }
  return;
});

export const selectContextCurrrencyCode = createSelector(selectContextCore, (state): string => {
  if (!!state) {
    return state.currency.code;
  }
  return;
});

export const selectContextIsBot = createSelector(selectContextCore, ({ isBot }): boolean => {
  return isBot;
});

export const selectContextSite = createSelector(selectContextCore, (state): string => {
  if (!!state) {
    return state.site;
  }
  return;
});

export const selectContextLanding = createSelector(selectContextCore, (state): boolean => {
  if (!!state) {
    return state.isLanding;
  }
  return;
});
